export const wordleDb = ({
  "letters": [
    {"key": "q"},
    {"key": "w"},
    {"key": "e"},
    {"key": "r"},
    {"key": "t"},
    {"key": "y"},
    {"key": "u"},
    {"key": "i"},
    {"key": "o"},
    {"key": "p"},
    {"key": "a"},
    {"key": "s"},
    {"key": "d"},
    {"key": "f"},
    {"key": "g"},
    {"key": "h"},
    {"key": "j"},
    {"key": "k"},
    {"key": "l"},
    
    {"key": "z"},
    {"key": "x"},
    {"key": "c"},
    {"key": "v"},
    {"key": "b"},
    {"key": "n"},
    {"key": "m"},
    {"key": "Enter"},
    {"key": "Backspace"},
    
  ],
  "solutions": [
    {"id": 1, "word": "ninja"},
    {"id": 2, "word": "spade"},
    {"id": 3, "word": "pools"},
    {"id": 4, "word": "drive"},
    {"id": 5, "word": "relax"},
    {"id": 6, "word": "times"},
    {"id": 7, "word": "train"},
    {"id": 8, "word": "cores"},
    {"id": 9, "word": "pours"},
    {"id": 10, "word": "blame"},
    {"id": 11, "word": "banks"},
    {"id": 12, "word": "phone"},
    {"id": 13, "word": "bling"},
    {"id": 14, "word": "coins"},
    {"id": 15, "word": "hello"}
  ]
})
